'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:style');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixStyle
     *
     * This web component conditionally loads a stylesheet resource.
     * It can check the GDPR status, delay the loading until after window.load,
     * or delay loading until after critical elements.
     * It must be placed in <body> as custom elements are not allowed in <head>.
     * The link element itself will be injected in <head>.
     *
     * @example
     *  <phoenix-style href="..." media="print" block-on-gdpr-applicable load-after-critical></phoenix-style>
     *
     */
    class PhoenixStyle extends pageClass.PhoenixElement {
        connectedCallback() {
            this.styleHref = this.getAttr('href', { required: true });
            this.media = this.getAttribute('media');

            const promises = [];

            if (this.hasAttribute('delay-load')) {
                promises.push(pageClass.util.whenPageLoaded());
            }
            if (this.hasAttribute('load-after-critical')) {
                promises.push(window.criticalElementsPromise);
            }

            if (this.hasAttribute('block-on-gdpr-applicable')) {
                if (!window.GdprStatus) {
                    throw new Error('window.GdprStatus is required');
                }
                promises.push(
                    new Promise((resolve, reject) => {
                        window.GdprStatus.isApplicable().then((isApplicable) => {
                            if (!isApplicable) {
                                resolve();
                            } else {
                                reject();
                            }
                        });
                    })
                );
            }

            Promise.all(promises)
                .then(() => {
                    this._injectStyles();
                })
                // If there is an error then the styles should not be loaded.
                .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                });
        }

        _injectStyles() {
            const style = document.createElement('link');
            style.rel = 'stylesheet';
            style.type = 'text/css';
            style.href = this.styleHref;

            if (this.media) {
                style.media = this.media;
            }

            document.head.appendChild(style);
        }
    }
    window.customElements.define('phoenix-style', PhoenixStyle);
    measure.end();
});
